module.exports = __webpack_public_path__ + "static/venice20892-b87d3ff22991f23f3a7958ea9dcfeb3e.webp";